import http from "../../../../config/BaseUrl"
import { eventViewLoading, eventViewSingleItem } from "./viewEventSlice"

export const extractEventView = (payload) => {
    const source = payload?.data || payload || {}
    return source.event || source.event_details || source.eventDetails || source.data?.event || source.data || source
}

export const EventViewItems = (id) => async (dispatch) => {
    try {
        dispatch(eventViewLoading(true))
        const res = await http.get(`show-event/${id}`)
        dispatch(eventViewSingleItem(extractEventView(res.data)))
    } catch (error) {
        dispatch(eventViewLoading(false))
    }
}
